import { NavLink } from 'react-router-dom'
import Icon from './Icon'

/**
 * The screens, in the order somebody works through them.
 *
 * Admins see everything. Accountants see the tracking screens (view-only,
 * enforced server-side too) and My Ledgers, but not Reports or Accounts
 * Team. An admin only gets My Ledgers when they're also in the accountant
 * directory. `adminOnly` hides a link; the APIs behind it refuse a
 * non-admin server-side (middlewares/auth.js).
 */
const NAV = [
  { to: '/ledger-collector', label: 'Ledger Collector', icon: 'ledger' },
  { to: '/ledger-reconciler', label: 'Ledger Reconciler', icon: 'scale' },
  { to: '/remediation', label: 'Ledger Remediation', icon: 'alert' },
  { to: '/reports', label: 'Ledger Reports', icon: 'overview', adminOnly: true },
  { to: '/team', label: 'Accounts Team', icon: 'clients', adminOnly: true },
  { to: '/my-ledgers', label: 'My Ledgers', icon: 'check', nonAdminOnly: true },
]

export default function Sidebar({ user, access, theme, onToggleTheme, onLogout }) {
  const nav = NAV.filter((item) =>
    access?.isAdmin ? !item.nonAdminOnly || Boolean(access.accountant) : !item.adminOnly
  )
  const sideLabel = access?.isAdmin ? (access.accountant ? 'Admin · Accountant' : 'Admin') : access?.accountant ? 'Accountant' : 'Member'
  return (
    <aside className="sidebar">
      <div className="brand">
        <div className="brand-mark">
          lereco<span>.</span>
        </div>
        <div className="brand-sub">Ledger tracking</div>
      </div>

      <div className="nav-section">
        {nav.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) => `nav-item${isActive ? ' on' : ''}`}
          >
            <span className="ico">
              <Icon name={item.icon} />
            </span>
            {item.label}
          </NavLink>
        ))}
      </div>

      <div className="side-bottom">
        {/* Who is signed in. Worth the line on a console where every action is
            written to an audit log under this person's name — and the only way
            to notice you are on a colleague's session before you act on it. */}
        {user && (
          <div className="side-row" style={{ cursor: 'default' }}>
            <span className="ico">
              <Icon name="user" />
            </span>
            <span style={{ minWidth: 0, display: 'flex', flexDirection: 'column' }} title={user.email || user.username || ''}>
              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {user.name || user.fullName || user.username || user.email}
              </span>
              <span className="side-role">{sideLabel}</span>
            </span>
          </div>
        )}

        <label className="side-row">
          <span className="ico">
            <Icon name="sun" />
          </span>
          Light mode
          <input className="ctl tg" type="checkbox" checked={theme === 'light'} onChange={onToggleTheme} />
          <span className="sw" style={{ marginLeft: 'auto' }} />
        </label>

        <button className="side-row danger" onClick={onLogout}>
          <span className="ico">
            <Icon name="logout" />
          </span>
          Log out
        </button>
      </div>
    </aside>
  )
}
